import getFromCdn from '@anm/helpers/getFromCdn';
import { Wrapper, MessageWrapper, VideoWrapper } from './Wrapper';

const RemovedProjectError = () => (
  <Wrapper>
    <VideoWrapper src={getFromCdn('videos/removed_project.mp4')} />
    <MessageWrapper>Project not found or deleted</MessageWrapper>
  </Wrapper>
);

export default RemovedProjectError;
